// Firestore 문서 모양. deals/firebase_sync.py 의 컬렉션 설명과 같아야 한다.

export type Specs = {
  category?: string | null;
  gpu?: string | null;
  cpu?: string | null;
  ram_gb?: number | null;
  ssd_gb?: number | null;
  screen_inch?: number | null;
  refresh_hz?: number | null;
  model?: string | null;
};

export type Coupon = {
  listed_price_krw: number | null;
  applied_price_krw: number | null;
  steps: string[];
  conditions: string[];
  scope: string | null;
  expires: string | null;
  evidence: string | null;
};

export type Deal = {
  id: string; // sha1(key)[:20]
  key: string;
  product: string;
  mall: string | null;
  category: string | null;
  price_krw: number | null;
  shipping_krw: number | null; // 0 = 무료, null = 미확인
  currency: string;
  price_foreign: number | null;
  effective_price: number | null;
  market_price: number | null;
  market_mall: string | null;
  thumb_url?: string | null; // 커뮤니티 본문에서 고른 대표 이미지
  market_url?: string | null; // 다나와 상품 페이지. 판매 링크가 없을 때 검색 대신 여기로 보낸다
  market_avg_90d?: number | null; // 최근 90일 다나와 최저가의 날짜별 평균 (수집기가 쌓는다)
  market_days?: number; // 그 평균에 들어간 관측 일수
  score: number;
  confidence: number;
  status: string; // feed | candidate
  components: Record<string, number | null>;
  penalties: Record<string, number>;
  reasons: string[];
  conditions: string[];
  specs: Specs;
  coupon: Coupon | null;
  product_url: string | null;
  affiliate_url?: string | null; // 파트너스 추적 링크. 있으면 구매 버튼은 이걸 쓴다
  affiliate_kind?: 'product' | 'search' | null; // 그 링크가 상품 페이지인지 판매처 검색인지
  urls: string[];
  sources: string[];
  titles: string[];
  posted_at: string | null;
  votes: number | null;
  comments: number | null;
  views: number | null;
  active: boolean;
};

export type AlertDoc = {
  id: string;
  condition_id: string | null;
  condition_text: string;
  deal_id: string;
  key: string;
  product: string;
  mall: string | null;
  effective_price: number | null;
  score: number;
  confidence: number;
  reasons: string[];
  url: string | null;
  product_url: string | null;
  message: string;
  read: boolean;
  created_at: Date | null;
};

export type Condition = {
  id: string;
  text: string;
  active: boolean;
  created_at: Date | null;
  parsed?: string; // 수집기가 되써 주는 해석 문구
  spec?: Record<string, unknown>;
  parsed_by?: string;
  local_id?: number;
  needs_confirm?: boolean; // 수집기가 문장만으로 상품을 못 좁혔다. 사용자 확인이 필요하다
  question?: string; // 그때 되물을 한 문장
  candidates?: { k: string; example?: string | null }[]; // 지금 잡고 있는 제품 말과 실제 수집 제목 예시
  keywords_override?: string[]; // 사용자가 직접 고른 목록. 수집기가 이걸 조건에 반영한다
  chat?: { role: 'ai' | 'user'; text: string }[]; // 상품을 좁히기 위한 되묻기 대화
  uid?: string; // 만든 사람. 없으면 주인을 적기 전에 만들어진 조건이다
  blocked?: boolean; // 무료 한도·크레딧 부족으로 AI 해석을 못 한 상태. 이유는 parsed 에 들어온다
};

export type Credits = { balance: number };

export type Label = '좋음' | '오탐' | '종료' | '낚시';
export const LABELS: Label[] = ['좋음', '오탐', '종료', '낚시'];

export type Summary = {
  run_at: string;
  posts: number;
  deals: number;
  feed: number;
  status_counts: Record<string, number>;
};
